module.exports = __webpack_public_path__ + "static/media/chevron-left.bd93489e.svg";